import React, { useState } from 'react';
import { sha256 } from '@noble/hashes/sha2';

  const CHUNK_SIZE = 1024*10; // 10KB per chunk

export const calculateSHA256 = async (file) => {
  const sliceSize = 1024*1024; // 10 MiB
  let start = 0;

  const hash = sha256.create(); // streaming hash

  while (start < file.size) {
    const slice = file.slice(start, start + sliceSize);
    const buffer = await slice.arrayBuffer();
    hash.update(new Uint8Array(buffer));
    start += sliceSize;
  }

  // Convert Uint8Array hash to hex string
  const hashBytes = hash.digest();
  const hashHex = Array.from(hashBytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
};


function App() {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [fileId, setFileId] = useState(0); // ID file fisso per esempio
  const [startOffset, setStartOffset] = useState(0); // Offset iniziale

  const uploadFileInChunks = async (file) => {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    let start = startOffset;
    let chunkIndex = 0;
    let hash = await calculateSHA256(file);
    console.log('SHA256 Hash:', hash);

    while (start < file.size) {
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      
      await fetch('http://localhost:8765/v1/cliente/ordine/upload/file', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
          'X-Fileid': fileId, // stessa ad ogni chunk
          'X-Offset': start, // indice del chunk
          'Authorization': "bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IkNMSUVOVEUwMSIsImV4cCI6MTc2MTA1Nzk0N30.o1I4Q9C9K1Ka8J5Dwzoa8sLqpdXu_-phCCMVKiNogeg"
        },
        body: chunk,
      });

      chunkIndex++;
      setProgress(Math.round((chunkIndex / totalChunks) * 100));

      start = end;
    }

    setUploading(false);
    alert('Upload completato!');
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploading(true);
      uploadFileInChunks(file);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Upload in chunk</h2>
      <p>File ID: {fileId}</p>
      <input type="number" value={fileId} onChange={(e) => setFileId(e.target.value)} />
      <p>Start Offset: {startOffset}</p>
      <input type="number" value={startOffset} onChange={(e) => setStartOffset(parseInt(e.target.value, 10))} />
      <input type="file" onChange={handleFileChange} disabled={uploading} />
      {uploading && <p>Progresso: {progress}%</p>}
    </div>
  );
}

export default App;